import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import classes from './dashboardPatients.module.scss';
import Button from '../../../_common/Form/Buttons/Button';
import { getPatientsRequest } from '../../../../store/actions/patients';
import { useQuery } from '../../../../utils/hooks/useQuery';
import AccountHelpers from '../../../../utils/accountHelpers';
import DashboardPatientsTable from './DashboardPatientsTable';
import Loader from '../../../_common/Loader/Loader';
import Utils from '../../../../utils/utils';
import Api from '../../../../api/api';

const DashboardPatients = () => {
  const { query, setQuery } = useQuery();

  const dispatch = useDispatch();
  const { patientList, pageCount } = useSelector((store) => store.patients);

  const [requestData, setRequestData] = useState({
    userId: AccountHelpers.getUser().id,
    page: query.page || 1,
    limit: query.limit || 15,
  });

  const [requestLoading, setRequestLoading] = useState(true);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const { page, limit } = requestData;

  useEffect(() => {
    (async () => {
      const data = Utils.deleteEmptyKeys({ ...requestData });

      await dispatch(getPatientsRequest(data));

      setRequestLoading(false);
    })();
  }, []);

  const onChangePageData = async (path, count) => {
    const newQuery = Utils.deleteEmptyKeys({ ...requestData, [path]: count });

    if (path === 'limit') {
      newQuery.page = 1;
    }

    setRequestData({ ...newQuery });

    await dispatch(getPatientsRequest({ ...newQuery }));

    delete newQuery.userId;

    setQuery(newQuery);
  };

  const downloadButtonClick = async () => {
    setDownloadLoading(true);

    await Api.getPatients({ ...requestData, download: true });

    setDownloadLoading(false);
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <h2>Patients</h2>

        <div className={classes.btns_wrapper}>
          <Button
            title="Download"
            type="button"
            downloadButton
            reverseColor
            loading={downloadLoading}
            onClick={downloadButtonClick}
          />
        </div>
      </div>

      <div className={classes.load_wrapper}>
        {requestLoading
          ? <Loader />

          : (
            <DashboardPatientsTable
              data={patientList}
              totalPage={+pageCount}
              page={+page - 1}
              limit={+limit}
              onChange={onChangePageData}
            />
          )}
      </div>
    </div>
  );
};

export default DashboardPatients;
